'use client';

import { useScrollAnimation } from '@/hooks/use-scroll-animation';
import { ReactNode } from 'react';

interface ScrollRevealProps {
  children: ReactNode;
  animation?: string;
  delay?: number;
  duration?: number;
  className?: string;
}

export function ScrollReveal({
  children,
  animation = 'slide-up',
  delay = 0,
  duration = 0.8,
  className = '',
}: ScrollRevealProps) {
  const { elementRef, isVisible } = useScrollAnimation({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <div
      ref={elementRef}
      className={className}
      style={{
        opacity: isVisible ? 1 : 0,
        animation: isVisible
          ? `${animation} ${duration}s ease-out ${delay}s both`
          : 'none',
      }}
    >
      {children}
    </div>
  );
}

